export const ChartColors = [
  '#F89C26',
  '#245971',
  '#CEC5AE',
  '#FF795D',
  '#4A7C59',
  '#FFDE8A',
  '#84AFE6',
  '#040926',
  '#78290F',
]

export const BarChartMarginLeft = 160

export const PercentileChartElementBarColors = {
  primary: '#FFAB40',
  secondary: '#245971',
  static: '#84AFE6',
  primaryTan: '#CEC5AE',
  secondaryGreen: '#4A7C59',
}

export const PercentileChartBarBackgroundColor = '#F5F5F5'
export const PercentileChartCohortBackgroundColor = '#E6E2D6'
export const PercentileChartCohortLabelBackgroundColorOutside = '#FFFFFF'

export const ChartColorOptions = (dataLength: number) => {
  let colors: any[] = []
  let defs = { patterns: [] as any[] }
  if (dataLength > ChartColors.length) {
    ChartColors.forEach((c) => {
      const pattern = {
        pattern: {
          backgroundColor: c,
          path: {
            d: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
            stroke: 'white',
          },
          width: 10,
          height: 10,
        },
      }
      colors.push(c)
      colors.push(pattern)
      defs.patterns.push(pattern)
    })
  } else {
    colors = colors.concat(ChartColors)
  }
  return {
    colors: colors,
    defs: defs,
  }
}

const SurveyTypeRespondents: { [key: string]: string } = {
  gpr: 'grantees',
  dpr: 'donors',
  'family survey': 'families',
  'staff survey': 'staff',
  spr: 'staff',
  'overall school experience': 'students',
  'student survey': 'students',
  'feedback for teachers': 'students',
}

export const GetCopyTableRowWords = (
  percentage: string,
  schoolName: string,
  surveyType: string
) => {
  let words = schoolName.length
    ? `${percentage} of students surveyed at ${schoolName} responded positively`
    : `${percentage} of students surveyed responded positively`
  if (surveyType.length) {
    let key = SurveyTypeRespondents[surveyType.toLowerCase()]
    let keyword = key ? key : 'respondents'
    words = words.replace('students', keyword)
  }
  return `${words} to the following:`
}

export const parseCohorts = (
  cohorts: { name: string }[],
  cohortSynonyms: any
) => {
  return cohorts.map((cohort) => {
    if (!cohortSynonyms) {
      return { name: cohort.name, value: cohort.name }
    }
    const key = Object.keys(cohortSynonyms).find((key) => {
      return cohortSynonyms[key].includes(cohort.name)
    })
    return key
      ? { name: cohort.name, value: key }
      : { name: cohort.name, value: cohort.name }
  })
}
